import { Checkbox as BaseCheckbox } from '@base-ui/react/checkbox';
import type { ReactNode } from 'react';
import { cx } from './utils';

export interface CheckboxProps {
  label: ReactNode;
  checked?: boolean;
  defaultChecked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

export function Checkbox({
  label,
  checked,
  defaultChecked,
  onCheckedChange,
  disabled = false,
  className,
}: CheckboxProps) {
  return (
    <label className={cx('ui-check-row', className)}>
      <BaseCheckbox.Root
        className="ui-checkbox"
        checked={checked}
        defaultChecked={defaultChecked}
        onCheckedChange={(nextChecked) => onCheckedChange?.(nextChecked)}
        disabled={disabled}
      >
        <BaseCheckbox.Indicator className="ui-checkbox__indicator" />
      </BaseCheckbox.Root>
      <span className="ui-check-row__label">{label}</span>
    </label>
  );
}
